/**
 * Notification API Service
 */

import apiClient from './apiClient';
import { NotificationDTO } from '../types/notification.types';

const BASE_PATH = '/v1/notifications';

class NotificationService {
  async getUserNotifications(userId: string): Promise<NotificationDTO[]> {
    const response = await apiClient.get<NotificationDTO[]>(`${BASE_PATH}/user/${userId}`);
    return response.data;
  }

  async getUnreadNotifications(userId: string): Promise<NotificationDTO[]> {
    const response = await apiClient.get<NotificationDTO[]>(`${BASE_PATH}/user/${userId}/unread`);
    return response.data;
  }

  async getUnreadNotificationCount(userId: string): Promise<number> {
    const response = await apiClient.get<number>(`${BASE_PATH}/user/${userId}/unread-count`);
    return response.data;
  }

  async markAsRead(notificationId: string): Promise<void> {
    await apiClient.patch(`${BASE_PATH}/${notificationId}/read`);
  }

  async markAllAsRead(userId: string): Promise<void> {
    await apiClient.patch(`${BASE_PATH}/user/${userId}/read-all`);
  }

  async getNotificationPreferences(facilityId: string): Promise<any> {
    const response = await apiClient.get(`/v1/notification-preferences?facilityId=${facilityId}`);
    return response.data;
  }

  async updateNotificationPreferences(data: any): Promise<any> {
    // Strictly filter payload to match expected fields from user's curl example
    // This prevents 500 errors caused by sending id, createdAt, etc. in POST/PUT bodies
    const payload = {
      medicationRemindersEnabled: !!data.medicationRemindersEnabled,
      medicationRemindersMins: Number(data.medicationRemindersMins || 0),
      missedShiftAlertsEnabled: !!data.missedShiftAlertsEnabled,
      incidentReportAlertsEnabled: !!data.incidentReportAlertsEnabled,
      facilityId: data.facilityId || "34c13c76-204d-43d5-90e3-56a50cfc4e84"
    };

    console.log('Sending Notification Preferences Payload:', payload);

    if (data.id) {
       console.log(`Performing PUT update for ID: ${data.id}`);
       const response = await apiClient.put(`/v1/notification-preferences/${data.id}`, payload);
       return response.data;
    }
    
    console.log('Performing POST create');
    const response = await apiClient.post('/v1/notification-preferences', payload);
    return response.data;
  }

  async deleteNotificationPreference(id: string): Promise<any> {
    const response = await apiClient.delete(`/v1/notification-preferences/${id}`);
    return response.data;
  }
}

export default new NotificationService();
